var Admin__NamecardsController;

import OrganizationNavigator from 'trunks/vue/admin/compositions/organizations_sidebar/organization_navigator.js';

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import OrganizationNamecards from 'trunks/vue/admin/compositions/organization_namecards/organization_namecards.js';

export default Admin__NamecardsController = (function() {
  class Admin__NamecardsController extends Skylark.App.BaseController {
    index() {
      var page;
      this._generateOrganizationSidebarView(this.getIds()[0]);
      page = this.getVars();
      return new OrganizationNamecards({
        el: DomMaster.find("#js-organization-container").node,
        propsData: {
          organization: page.organization,
          organizationApplicationsCount: page.pending_organization_applications_count,
          namecards_count: page.namecards_count
        }
      });
    }

  };

  Admin__NamecardsController.include(GenerateMorePopover);

  Admin__NamecardsController.include(OrganizationNavigator);

  return Admin__NamecardsController;

}).call(this);
